export default {
  isHomePlayer: (state, getters, rootState) => rootState.common.userDetails.msisdn === state.playersDetails.homePlayerMSISDN,
  isCurrentThemeChooser(state, getters, rootState) {
    if (state.playersDetails.homePlayerMSISDN === state.playersDetails.awayPlayerMSISDN) {
      return state.currentRoundNumber % 2 === 1;
    } return rootState.common.userDetails.msisdn === state.currentThemeChooserMSISDN;
  },
  isCurrentRoundWinner: (state, getters, rootState) => rootState.common.userDetails.msisdn === state.currentRoundWinnerMSISDN
                                                    && rootState.common.userDetails.username === state.currentRoundWinnerUsername,
  isFinalRound: state => state.currentRoundNumber === state.finalRoundNumber,
  isGameWinner: (state, getters, rootState) => rootState.common.userDetails.msisdn === state.gameWinnerMSISDN
                                            && rootState.common.userDetails.username === state.gameWinnerUsername,
  isEqualAmountOfCorrectAnswers: (state) => {
    const homePlayerNumberOfCorrectAnswers = state.homePlayerCorrectAnswersCSSClasses.filter(answer => answer === 'correct');
    const awayPlayerNumberOfCorrectAnswers = state.awayPlayerCorrectAnswersCSSClasses.filter(answer => answer === 'correct');
    return homePlayerNumberOfCorrectAnswers.length === awayPlayerNumberOfCorrectAnswers.length;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/game/getters.js